<template>
  <base-section id="map" space="0">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.7679170800902!2d103.8934127!3d1.3147665!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1817b27284df%3A0x7a2b0fab2e5ce39d!2sCity%20Plaza!5e0!3m2!1sen!2slk!4v1776245641230!5m2!1sen!2slk"
      height="550"
      style="border:0; display: bloc"
      allowfullscreen=""
      aria-hidden="true"
      frameborder="0"
      tabindex="0"
      loading="lazy"
      width="100%"
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
  </base-section>
</template>

<script>
export default {
  name: "SectionMap",

  provide: {
    heading: { align: "center" },
  },
};
</script>
